export const getUser = state => state
export const isLoggedIn = state => state.authToken !== null



// WEBPACK FOOTER //
// ./src/vuex/modules/user/getters.js